"use client"

import React from "react"
import { usePathname, useRouter } from "next/navigation"
import TC_Wrapper from "react-tag-commander"

import { buildAnalyticsLinks } from "@/lib/utils"
import { Button } from "@/components/ui/atoms"

const GoBackButton = ({ label }: { label: string }) => {
  const wrapper = TC_Wrapper.getInstance()
  const router = useRouter()
  const pathname = usePathname()

  const handleGoBack = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    // Extract the segments of the current URL
    const segments = pathname.split("/").filter(Boolean)

    // Remove the last segment to go back to the previous page and ensure there's at least more than one segment
    if (segments.length > 2) {
      segments.pop()
    }

    const previousPageUrl = segments.join("/")
    // Convert the path to a URL object, using window.location.origin as the base URL
    const previousPageFullUrl = new URL(
      `${window.location.origin}/${previousPageUrl}`
    )

    const analytics = buildAnalyticsLinks(
      [label],
      previousPageFullUrl,
      "navigation"
    )
    wrapper.triggerEvent(
      analytics.type,
      event.currentTarget,
      analytics.chapters
    )

    router.push(`/${previousPageUrl}`)
  }

  return (
    <Button
      iconLeft="ArrowLeft"
      variant="ghost"
      className="p-0"
      onClick={handleGoBack}
    >
      {label}
    </Button>
  )
}

export { GoBackButton }
